import ProviderBusinessFilterFields from "@/components/ProviderBusinessFilterFields.vue";
import businessInfoAddressMethods from "@/controllers/businessInfoAddressMethods";
import businessInfoBenefitMethods from "@/controllers/businessInfoBenefitMethods";
import businessInfoDataMethods from "@/controllers/businessInfoDataMethods";
import businessInfoFileMethods from "@/controllers/businessInfoFileMethods";
import businessInfoLifecycle from "@/controllers/businessInfoLifecycle";
import { PROVIDER_BENEFIT_FILTER_OPTIONS } from "@/utils/providerBenefits";

export default {
  components: { ProviderBusinessFilterFields },
  data() {
    return {
      loading: true,
      thumbnailUploading: false,
      form: {
        type: "",
        comments: "",
        visitNoticesText: "",
        description: "",
        phone: "",
        address: "",
        detailAddress: "",
        landMark: "",
        workTime: "",
        region: "",
        services: [],
        thumbnail: "",
        thumbnailImages: [],
        images: [],
        // 예물맵 필터 — 매장 명시 입력
        amenities: {
          parking: false,
          privateConsultation: false,
          oneOnOne: false,
        },
        pricingPolicy: "",
        reservationRequired: false,
        comparisonEstimateEnabled: true,
      },
      benefitFilterOptions: PROVIDER_BENEFIT_FILTER_OPTIONS,
      filterBenefits: [],
      consultationBenefits: [],
      addressModalOpen: false,
    };
  },
  ...businessInfoLifecycle,
  methods: {
    ...businessInfoAddressMethods,
    ...businessInfoBenefitMethods,
    ...businessInfoDataMethods,
    ...businessInfoFileMethods,
  },
};
